module.exports = __webpack_public_path__ + "static/img/coner1.5f70c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/coner1.png
// module id = QgWz
// module chunks = 1